import auth from '../services/auth';
import { logout } from '../redux/userSlice';
import { store } from '../redux/store';
import { clearTeamAssistantQueryPersist } from '../libs/teamAssistantQueryPersist';

export const signOutNow = (dispatch, navigate) => {
  const userId = store.getState().user.currentUser?.id;
  clearTeamAssistantQueryPersist(userId);

  auth.logout().catch(() => {});
  localStorage.removeItem('token');
  dispatch(logout());
  navigate('/login', { replace: true });
};
